/**
 * 是否下单选择Authority to leave
 */
export const ATL_TYPE = {
  YES: 1,
  NO: 0,
} as const

export const ATL_TYPE_OPTIONS = [
  {
    label: 'component.serviceProvider.codYes',
    value: ATL_TYPE.YES,
  },
  {
    label: 'component.serviceProvider.codNo',
    value: ATL_TYPE.NO,
  },
]
